import { CallKind, ReviewTab } from '../types';

export const ACTIVE_TAB_TO_CALL_KIND: Record<ReviewTab, CallKind> = {
  [ReviewTab.SIMULATIONS]: CallKind.SIMULATION,
  [ReviewTab.REAL_CALLS]: CallKind.REAL,
};

export const CALL_KIND_TO_ACTIVE_TAB: Record<CallKind, ReviewTab> = {
  [CallKind.SIMULATION]: ReviewTab.SIMULATIONS,
  [CallKind.REAL]: ReviewTab.REAL_CALLS,
};
